import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/landing';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-cream-deep" data-id="element-200" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" style={{
      backgroundColor: "#FFFFFF",
      backgroundImage: "none"
    }} data-id="element-201" data-mp="1mxxxd8vmeqlo">
        <SectionHeading eyebrow="⭐ TESTIMONIOS REALES" title={<>
              Lo que puede cambiar cuando empiezas a{' '}
              <span className="italic text-coral" data-id="element-203" data-mp="1i1z3x6vfqiee">estudiar visualmente.</span>
            </>} data-id="element-202" data-mp="1d24e76nebyux" />

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-204" data-mp="141y1vo3fp4xc">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl bg-cream p-8" data-id="element-205" data-mp="181zwxeenz03n">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-206" data-mp="2yeo18lckn6c4">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-coral text-coral" aria-hidden="true" data-id="element-207" data-mp="32g98nr6c6sex" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 font-display text-lg leading-relaxed text-ink" data-id="element-208" data-mp="2uzhpp5sxqqao">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-209" data-mp="34qceagtnm1za">
                <p className="text-sm font-semibold text-ink" data-id="element-210" data-mp="34tgtsackkk59">{testimonial.name}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}